// FORBIDDEN + a message that mentions "limit" is our signal that the user
// hit a plan cap. We don't parse the structured `cause` from the TRPC
// response (it isn't serialized by default); the message text is enough
// to drive the upgrade-toast UX.
export function isLimitReachedError(err: unknown): boolean {
	if (!err || typeof err !== 'object') return false
	const e = err as {
		message?: string
		data?: { code?: string } | null
	}
	const code = e.data?.code
	if (code !== 'FORBIDDEN') return false
	const msg = e.message?.toLowerCase() ?? ''
	return msg.includes('limit') || msg.includes('upgrade')
}
